import { Collapse } from '@hapvida/hapvida-core-components';

import { useFilterParams } from '@hooks';
import { ITEMS_LIMIT_PER_PAGE } from '@constants';

import type { BeneficiaryServicesListCardProps } from './types';
import { BeneficiaryServicesColumns } from './constants/columns';
import { useBeneficiaryServicesListRows } from './useBeneficiaryServicesListRows';

export function BeneficiaryServicesListCard({
  beneficiaries,
}: Readonly<BeneficiaryServicesListCardProps>) {
  const { handleTableOrderChange, handlePageChange, currentPage, tableOrder } =
    useFilterParams();

  const handleChangePage = (_event: unknown, newPage: number) => {
    handlePageChange(newPage);
  };

  const { rows } = useBeneficiaryServicesListRows({
    beneficiaries: beneficiaries?.beneficiaryServices ?? [],
  });

  return (
    <Collapse
      count={
        beneficiaries
          ? Math.ceil(beneficiaries.total / ITEMS_LIMIT_PER_PAGE)
          : undefined
      }
      from={
        beneficiaries
          ? ITEMS_LIMIT_PER_PAGE * (currentPage - 1) +
            beneficiaries.beneficiaryServices.length
          : undefined
      }
      TableHeadColumns={BeneficiaryServicesColumns}
      onOrderChange={handleTableOrderChange}
      baseTableProps={{
        tableContainerHeight: '100%',
      }}
      onPageChange={handleChangePage}
      to={beneficiaries?.total}
      currentPage={currentPage}
      tableOrder={tableOrder}
      data={rows}
    />
  );
}
